module.exports = __webpack_public_path__ + "static/media/vegspringroll.363bccad.jpg";